import createArea from "./createArea";
export default createArea;
